import { setStatus, agentId } from './global';
import { term, setPTYSize } from './terminal';
import { register, routeIncoming } from './message-router';

// --- Heartbeat keep the websocket alive ---
register('ping', () => {});

// --- WebSocket Connection Manager ---
class SocketManager {
  url: string;
  wsVoiceUrl: string;
  ws: WebSocket | null = null;
  msgQueue: string[] = [];
  reconnectInterval = 1000;
  maxReconnectInterval = 10000;
  isConnecting = false;

  constructor(url: string, wsVoiceUrl: string) {
    this.url = url;
    this.wsVoiceUrl = wsVoiceUrl;
  }

  connect(): void {
    if (this.isConnecting) return;
    this.isConnecting = true;

    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.isConnecting = false;
      this.reconnectInterval = 1000;

      // UI Updates
      setStatus(`Connected to Agent: ${agentId}`, 'text-green-500');
      term.focus();

      // Flush Queue
      while (this.msgQueue.length > 0) {
        const msg = this.msgQueue.shift();
        if (msg && this.ws) {
          this.ws.send(msg);
        }
      }

      // Refresh Terminal Size
      setPTYSize();
      // Get current AI mode
      this.send('info', {});
    };

    this.ws.onmessage = async (event: MessageEvent) => {
      const cmds = routeIncoming(JSON.parse(event.data as string));
      for (const c of cmds ?? []) this.ws?.send(JSON.stringify(c));
    };

    this.ws.onclose = () => {
      this.isConnecting = false;
      console.log("Disconnected, attempting reconnect...");
      setStatus("Reconnecting...", "text-yellow-500");
      this.scheduleReconnect();
    };

    this.ws.onerror = (err: Event) => {
      console.error("WS Error", err);
      this.ws?.close();
    };
  }

  scheduleReconnect(): void {
    setTimeout(() => {
      this.connect();
      this.reconnectInterval = Math.min(this.reconnectInterval * 1.5, this.maxReconnectInterval);
    }, this.reconnectInterval);
  }

  send(type: string, data: unknown): void {
    const payload = JSON.stringify({ type, data });

    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(payload);
    } else {
      this.msgQueue.push(payload);
    }
  }
}

// --- Initialize Socket ---
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const wsUrl = `${protocol}//${window.location.host}/ws/client/${agentId}`;
const wsVoiceUrl = `${protocol}//${window.location.host}/ws/voice/${agentId}`;

const socketManager = new SocketManager(wsUrl, wsVoiceUrl);
socketManager.connect();

export { socketManager };
